import { PersonalInfoFormActionType } from "app/hooks";
import { useCheckoutInfoContext } from "pages/checkout/providers/CheckoutInfoProvider";
import { useInfoFormErrorsContext } from "pages/checkout/providers/InfoFormErrorsProvider";
import FormGroup from "shared/ui/FormGroup";
import Input from "shared/ui/input";
import Label from "shared/ui/label";
import Phone from "shared/ui/phone";
import { concatClassnames } from "shared/utils/concatClassnames";

interface CheckoutInfoPersonalProps {
  className?: string;
}

const CheckoutInfoPersonal = ({ className }: CheckoutInfoPersonalProps) => {
  const { state, dispatch } = useCheckoutInfoContext();
  const { formErrors } = useInfoFormErrorsContext();
  const { name, surname, email, phoneNumber } = state;

  const updateName = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_NAME,
      payload: e.target.value,
    });
  };
  const updateSurname = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_SURNAME,
      payload: e.target.value,
    });
  };
  const updateEmail = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_EMAIL,
      payload: e.target.value,
    });
  };
  const updatePhone = (phone: string) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_PHONE_NUMBER,
      payload: phone,
    });
  };

  return (
    <div className={concatClassnames("gg-grid gg-gap-5", className)}>
      <FormGroup
        className="gg-col-span-12 md:gg-col-span-6 lg:gg-col-span-12"
        errorMessage={formErrors.name}
        displayError={state.isSubmitting && formErrors.name.length !== 0}
      >
        <Label htmlFor="name" className="gg-mb-1" required>
          Voornaam
        </Label>
        <Input
          id="name"
          placeholder="Wat is je naam?"
          value={name}
          onChange={updateName}
          error={formErrors.name.length !== 0}
          required
          data-testid="form-personal-name"
        />
      </FormGroup>

      <FormGroup
        className="gg-col-span-12 md:gg-col-span-6 lg:gg-col-span-12"
        errorMessage={formErrors.surname}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="surname" className="gg-mb-1" required>
          Achternaam
        </Label>
        <Input
          id="surname"
          placeholder="Wat is je achternaam?"
          value={surname}
          onChange={updateSurname}
          error={!!formErrors["surname"].length}
          required
          data-testid="form-personal-surname"
        />
      </FormGroup>

      <FormGroup
        className="gg-col-span-12"
        errorMessage={formErrors["email"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="email" className="gg-mb-1" required>
          E-mailadres
        </Label>
        <Input
          type="email"
          id="email"
          placeholder="Voor de bevestiging"
          value={email}
          onChange={updateEmail}
          error={!!formErrors["email"].length}
          required
          data-testid="form-personal-email"
        />
      </FormGroup>

      <FormGroup
        className="gg-col-span-12"
        errorMessage={formErrors["phoneNumber"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="phoneNumber" className="gg-mb-1" required>
          Telefoonnummer
        </Label>
        <Phone
          id="phoneNumber"
          error={!!formErrors["phoneNumber"].length}
          value={phoneNumber}
          onChange={(phone: string) => {
            updatePhone(phone);
          }}
          data-testid="form-personal-phone-number"
        />
      </FormGroup>
    </div>
  );
};
export default CheckoutInfoPersonal;
